/* eslint-disable react/prop-types */
import { useEffect, useState } from "react"
import { Modal, Form, Button } from "react-bootstrap"
import Loader from "../../../components/Loader"

const ReassignModal = ({ show, onHide, users, onPressSubmit, isLoading }) => {
    const [selectedUserId, setSelectedUserId] = useState("") // State to store the selected user ID
    const [agencyUsers, setAgencyUsers] = useState([]) // State to store the selected user ID

    useEffect(() => {
        users?.length && setAgencyUsers(users)
    }, [show])

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered>
            <Modal.Header closeButton>
                <Modal.Title>Reassign User</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Loader show={isLoading} />
                <Form>
                    <Form.Group controlId="formUser">
                        <Form.Label>Select User</Form.Label>
                        <Form.Select
                            className="form-select-sm"
                            value={selectedUserId}
                            required
                            onChange={(e) => setSelectedUserId(e.target.value)}>
                            <option value={""}>Select User</option>
                            {agencyUsers.map((user) => (
                                <option
                                    key={user.id}
                                    value={user.id}>
                                    {user.firstName} {user.lastName}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    className="btn-sm"
                    variant="secondary"
                    onClick={onHide}>
                    Cancel
                </Button>
                <Button
                    className="btn-sm"
                    variant="primary"
                    disabled={selectedUserId === ""}
                    onClick={() => {
                        onPressSubmit(selectedUserId)
                    }}>
                    Assign
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ReassignModal
